import { validateAccountNumber } from "src/app/bank.config"
import { ERROR_MESSAGES } from "src/app/constants"

export class FinanceAccount {
	constructor(
		private _code?: string,
		private _bank?: string,
		private _accNumber?: string,
		private _description?: string,
		private _directors?: string,
		private _createdOn?: string,
		private _createdBy?: string,
		private _disabled?: boolean,
		private _id?: number,
		private _businessIds?: number[]
	) { }

	set Id(id: number) { this._id = id }
	get Id(): number { return this._id }

	set Code(code: string) { this._code = code }
	get Code(): string { return this._code }

	set Bank(bank: string) { this._bank = bank }
	get Bank(): string { return this._bank }

	set AccNumber(number: string) { this._accNumber = number }
	get AccNumber(): string { return this._accNumber }

	set Description(desc: string) { this._description = desc }
	get Description(): string { return this._description }

	set Directors(directors: string) { this._directors = directors }
	get Directors(): string { return this._directors }

	set CreatedBy(createdBy: string) { this._createdBy = createdBy }
	get CreatedBy(): string { return this._createdBy }

	set CreatedOn(createdOn: string) { this._createdOn = createdOn }
	get CreatedOn(): string { return this._createdOn }

	set Disabled(disabled: boolean) { this._disabled = disabled }
	get Disabled(): boolean { return this._disabled }

	set BusinessIds(value: number[]) { this._businessIds = value }
	get BusinessIds(): number[] { return this._businessIds }

	nullValidate(): string[] {
		const errors: string[] = [];
		if (this._code == null || this._code.trim().length === 0)
			errors.push(ERROR_MESSAGES.EMPTY_FIELD('Code'));
		if (this._bank == null || this._bank.trim().length === 0)
			errors.push(ERROR_MESSAGES.EMPTY_FIELD('Bank'));
		if (this._description == null || this._description.trim().length === 0)
			errors.push(ERROR_MESSAGES.EMPTY_FIELD('Description'));
		if (this._directors == null || this._directors.trim().length === 0)
			errors.push(ERROR_MESSAGES.EMPTY_FIELD('Directors'));
		if (this._accNumber == null || this._accNumber.trim().length === 0)
			errors.push(ERROR_MESSAGES.EMPTY_FIELD('Account Number'));
		if (this._accNumber.trim().length > 0 && !validateAccountNumber(this._bank, this._accNumber)) {
			errors.push(ERROR_MESSAGES.INVALID_BANK_ACCOUNT);
		}
		return errors;
	}
}

export interface IAPIFinanceAccount {
	code: string;
	bank: string;
	number: string;
	description: string;
	directors: string;
}
